import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "delete-modal-content" }
const _hoisted_5 = { class: "icon-container" }
const _hoisted_6 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_FileInput = _resolveComponent("FileInput")!
  const _component_FileDisplay = _resolveComponent("FileDisplay")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "group-select col" }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "user-select col" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Select, {
        id: "edit-document-signature-required",
        name: "signature",
        label: "documents.signature-required",
        placeholder: _ctx.getPlaceholder,
        value: _ctx.model.signature?.toLowerCase(),
        items: _ctx.signatureItems,
        error: _ctx.errors.signature,
        required: "",
        onChange: _ctx.handleSelectChange
      }, null, 8, ["placeholder", "value", "items", "error", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.model.file && !_ctx.model.documentContents?.fileName)
        ? (_openBlock(), _createBlock(_component_FileInput, {
            key: 0,
            name: "file-upload",
            acceptString: "application/pdf",
            existingFile: null,
            onAddFile: _ctx.handleAddFile
          }, null, 8, ["onAddFile"]))
        : (_openBlock(), _createBlock(_component_FileDisplay, {
            key: 1,
            fileName: 
          _ctx.model.file ? _ctx.model.file.name : _ctx.model.documentContents.fileName
        ,
            fileType: "pdf",
            editAcceptString: "application/pdf",
            downloadable: "",
            deletable: "",
            onDownload: _ctx.handleDownloadFile,
            onRemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleToggleDeleteModal())),
            onEdit: _ctx.handleEditFile
          }, _createSlots({ _: 2 }, [
            (_ctx.model.file)
              ? {
                  name: "secondaryText",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getFileSize(_ctx.model.file.size)), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["fileName", "onDownload", "onEdit"]))
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.showDeleteModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDeleteModal) = $event))
    }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "delete-modal" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              class: "icon",
              icon: "exclamation-triangle",
              size: "3x"
            })
          ]),
          _createElementVNode("h4", null, [
            _createVNode(_component_TranslatedText, { path: "prompts.warning" })
          ]),
          _createVNode(_component_TranslatedText, { path: "documents.delete-warning" })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            text: "common.cancel-action",
            size: "sm",
            variant: "secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleToggleDeleteModal()))
          }),
          _createVNode(_component_Button, {
            text: "common.delete",
            size: "sm",
            variant: "error",
            onClick: _ctx.handleDeleteFile
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}